class ReservationModel {
  constructor () {
    this.service = 'caregiver'
    this.requireCaregiverTypes = []
    this.workType = 'hr12'
    this.shift = {
      type: '',
      start: '',
      end: '',
    }
    this.dates = []
    this.price = {
      discount: {
        type: '',
        value: 0,
      },
    }
    this.canEditRequireCaregiverTypes = true
    this.address = {
      address: '',
      province: '',
      district: '',
      subdistrict: '',
      landmark: ''
    }
    this.hospital = {
      name: '',
      province: '',
      room: '',
      landmark: '',
      care: false,
    }
    this.addressLatLng = ''
    this.hospitalLatLng = ''
    this.promotionCode = ''
    this.fake = false
    this.recurring = false
    this.patientNote = ''
    this.caregiverNote = ''
    this.paid = ''
    this.daysOff = []
    this.canEditDaysOff = true
    this.customerType = ''
  }

  static fromJSON (json) {
    let reservation = new ReservationModel()
    reservation.id = json.id
    reservation.patientId = json.patientId
    reservation.service = json.service
    reservation.customerType = json.customerType
    reservation.index = json.index
    reservation.requireCaregiverTypes = json.requireCaregiverTypes
    reservation.workType = json.workType
    reservation.shift = json.shift
    reservation.dates = json.dates
    reservation.price = json.price
    reservation.canEditRequireCaregiverTypes = json.canEditRequireCaregiverTypes
    reservation.address = json.address
    reservation.hospital = json.hospital
    reservation.addressLatLng = json.addressLatLng
    reservation.hospitalLatLng = json.hospitalLatLng
    reservation.promotionCode = json.promotionCode
    reservation.recurring = json.recurring
    reservation.patientNote = json.patientNote
    reservation.caregiverNote = json.caregiverNote
    reservation.paid = json.paid
    reservation.daysOff = json.daysOff
    reservation.canEditDaysOff = json.canEditDaysOff
    return reservation
  }

  static listfromJSON (json) {
    const list = json.list
    let result = []
    if (list) {
      for (let i = 0; i < list.length; i++) {
        const item = ReservationModel.fromJSON(list[i])
        result.push(item)
      }
    }
    return result
  }
}

class ReservationDefaultPricing {
  netPrice () {
    return 0
  }
  valueDiscount () {
    return 0
  }
}

class ReservationPricing {
  constructor (price) {
    this.price = price
  }
  netPrice () {
    return this.price.net
  }
  valueDiscount () {
    return this.price.discount
  }
}

export {
  ReservationModel,
  ReservationPricing,
  ReservationDefaultPricing,
}
